import { Form, Space, Switch, TableColumnType } from "antd";
import moment from "moment";
import { CategoryName } from "../../../../models/category";
import { Dimen } from "../../../../models/dimen";
import React from "react";
import styles from "../purchaseControl.module.css";
import { useSelector } from "react-redux";
import { selectSettings } from "../../../user/setting/settingSlice";
import { Checks } from "../../../../models/setting";

// 进货管理详情
export const PurchaseControlDetailColumns = (
  startIndex: number
): TableColumnType<any>[] => {

  const settings = useSelector(selectSettings)
  // 新老目录展示方式 (老目录没有区分药品类别/无型号)
  const getProcuctInfo = (item: any) => {
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ? item.packSpec : '-'
    const spec = item.spec ? item.spec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
    const model = item.model ? '/' + item.model : ''

    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
        //  生产厂家 + 包装规格  + 剂型 
        return tenantSupplierName + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 包装规格 + 型号 
        return tenantSupplierName + '/' + packSpec + model
      } else {
        // 生产厂家 + 包装规格 
        return tenantSupplierName + '/' + packSpec
      }
    } else {
      if (materialsCategory == '0') {
        //  生产厂家 + 规格  + 剂型 
        return tenantSupplierName + '/' + spec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 规格 +  型号 
        return tenantSupplierName + '/' + spec + model
      } else {
        // 生产厂家 + 规格 
        return tenantSupplierName + '/' + spec
      }
    }
  }
  return [
    {
      title: "序号",
      align: "center",
      key: "no",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "业务单号",
      align: "center",
      dataIndex: "putNumber",
      width: Dimen.PutNumber,
      key: "putNumber",
      sorter: (a: any, b: any) => a.putNumber - b.putNumber,
    },
    {
      title: "商品类别",
      align: "center",
      dataIndex: "drugCategory",
      width: Dimen.categoryType,
      key: "drugCategory",
    },
    {
      title: "商品信息",
      align: "left",
      dataIndex: "name",
      key: "name",
      width: Dimen.PutNumber,
      render: function Element(_, record) {
        return (
          <div style={{ height: "55px" }}>
            <p
              className={styles.nameText}
            >
              {record.name}
            </p>
            <p
             className={styles.productText}
            >
              {getProcuctInfo(record)}
            </p>
          </div>
        );
      },
      sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: "业务类别",
      align: "center",
      key: "category",
      width: Dimen.Category,
      render: (_, t) => {
        return CategoryName(t.category);
      },
    },
    {
      title: "业务日期",
      align: "center",
      dataIndex: "createTime",
      width: Dimen.Time,
      key: "upAccountTime",
      render: (_, t) => {
        const upAccountTime = (t.createTime).substring(0, 10);
        return upAccountTime;
      },
      sorter: (a: any, b: any) =>
        moment(a.createTime).unix() - moment(b.createTime).unix(),
    },
    {
      title: "数量",
      align: "center",
      dataIndex: "count",
      width: Dimen.Count,
      key: "count",
      render: function element(_, t) {
        return (
          <div
            style={{
              color: t?.category == 2 ? 'red' : '',
            }}
          >
            {t.count?.toFixed(2)}
          </div>
        )
      },
    },
    {
      title: "进价",
      align: "center",
      dataIndex: "unitPrice",
      width: Dimen.Price,
      key: "unitPrice",
      render: function element(_, t) {
        return (
          <div
            style={{
              color: t?.category == 2 ? 'red' : '',
            }}
          >
            {Number(t?.unitPrice)?.toFixed(2)}
          </div>
        )
      },
    },
    {
      title: "总金额",
      align: "center",
      dataIndex: "totalPrice",
      width: Dimen.Price,
      key: "totalPrice",
      render: function element(_, t) {
        return (
          <div
            style={{
              color: t?.category == 2 ? 'red' : '',
            }}
          >
            {Number(t?.totalPrice)?.toFixed(2)}
          </div>
        )
      },
    }
  ];
};
